export default __webpack_public_path__ + "static/media/coin.28c7d661.svg";